<template>
    <NotesView :related-id="project.id" related-type="project" />
</template>

<script>
import NotesView from "../Note/NotesView";

export default {
    name: "ProjectNotesView",
    components: {
        NotesView
    },
    props: {
        project: {
            type: Object,
            required: true
        }
    },
    setup() {
        return {};
    }
};
</script>
